// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__Xt47n","item":"PaymentsMobile_item__OUB_1","label":"PaymentsMobile_label__QqQ8-","amount":"PaymentsMobile_amount__2RX-7"};